var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "invoice-dashboard" },
      [
        _c("InvoiceHeader", {
          attrs: {
            title: "Invoices",
            lastUpdated: "",
            buttonText: "Create New",
          },
          on: { buttonAction: _vm.createNewInvoice },
        }),
        _c(
          "div",
          {
            staticClass:
              "card-container flex justify-between mb-7 font-outfit -m-2",
          },
          _vm._l(_vm.cards, function (card) {
            return _c("InvoiceSummaryCard", {
              key: card.id,
              attrs: {
                icon: card.icon,
                description: card.description,
                color: card.color,
                amount: card.amount,
              },
            })
          }),
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "table-holder shadow bg-white rounded-md md py-4 px-7 font-outfit",
          },
          [
            _vm.currentUser.role !== "ADMIN"
              ? _c("InvoiceTabs", {
                  attrs: { tabs: _vm.tabs, activeTab: _vm.activeTabIndex },
                  on: {
                    "update:activeTab": function ($event) {
                      _vm.activeTabIndex = $event
                    },
                    "update:active-tab": function ($event) {
                      _vm.activeTabIndex = $event
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "tab-0",
                        fn: function () {
                          return [
                            _c("InvoiceTable", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                headers: _vm.headers,
                                data: _vm.invoiceData,
                                actions: _vm.tableActions,
                              },
                              on: {
                                sort: _vm.handleSort,
                                view: _vm.handleEdit,
                                copy: _vm.handleCopy,
                                action: _vm.handleAction,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-1",
                        fn: function () {
                          return [
                            _c("InvoiceTable", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                headers: _vm.headers,
                                data: _vm.invoiceData,
                                actions: _vm.tableActions,
                              },
                              on: {
                                sort: _vm.handleSort,
                                action: _vm.handleAction,
                                view: _vm.handleEdit,
                                copy: _vm.handleCopy,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-2",
                        fn: function () {
                          return [
                            _c("InvoiceTable", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                headers: _vm.headers,
                                data: _vm.invoiceData,
                                actions: _vm.tableActions,
                              },
                              on: {
                                sort: _vm.handleSort,
                                action: _vm.handleAction,
                                view: _vm.handleEdit,
                                copy: _vm.handleCopy,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-3",
                        fn: function () {
                          return [
                            _c("InvoiceTable", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                headers: _vm.headers,
                                data: _vm.invoiceData,
                                actions: _vm.tableActions,
                              },
                              on: {
                                sort: _vm.handleSort,
                                action: _vm.handleAction,
                                view: _vm.handleEdit,
                                copy: _vm.handleCopy,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-4",
                        fn: function () {
                          return [
                            _c("InvoiceTable", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                headers: _vm.headers,
                                data: _vm.invoiceData,
                                actions: _vm.tableActions,
                              },
                              on: {
                                sort: _vm.handleSort,
                                action: _vm.handleAction,
                                view: _vm.handleEdit,
                                copy: _vm.handleCopy,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1689270022
                  ),
                  model: {
                    value: _vm.activeTabIndex,
                    callback: function ($$v) {
                      _vm.activeTabIndex = $$v
                    },
                    expression: "activeTabIndex",
                  },
                })
              : _c(
                  "InvoiceTabs",
                  {
                    attrs: {
                      isAdmin: _vm.currentUser.role === "ADMIN",
                      sort_by: _vm.sortBy,
                      sort_direction: _vm.sortDirection,
                      tabs: _vm.tabs,
                      selectedRows: _vm.selectedRows,
                      activeTab: _vm.activeTabIndex,
                    },
                    on: {
                      sort: _vm.handleSort,
                      "update:activeTab": function ($event) {
                        _vm.activeTabIndex = $event
                      },
                      "update:active-tab": function ($event) {
                        _vm.activeTabIndex = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "tab-0",
                        fn: function () {
                          return [
                            _vm.currentUser.role === "ADMIN" &&
                            _vm.selectedRows.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "invoice-buttons" },
                                  [
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Approved",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("APPROVED")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Rejected",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("REJECTED")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Pending Approval",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("PENDING")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Paid",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("PAID")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Payment Sent",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus(
                                            "PAYMENT SEND"
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("TableView", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                columns: _vm.columns,
                                data: _vm.invoiceData,
                                hasActions: true,
                                selectedRows: _vm.selectedRows,
                              },
                              on: {
                                sort: _vm.handleSort,
                                "update:selectedRows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                                "update:selected-rows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "status",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "relative" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "status",
                                            class: row.status,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.status(row.status)) +
                                                " "
                                            ),
                                            _vm.status(row.status) ===
                                            "Payment Sent"
                                              ? _c(
                                                  "Tooltip",
                                                  {
                                                    staticClass:
                                                      "flex items-center ml-2",
                                                    attrs: {
                                                      variant:
                                                        _vm.TooltipVariants
                                                          .DARK,
                                                      title:
                                                        "Payment is being processed at the bank. The funds may not be available yet at this time.",
                                                      tooltipClasses: "w-56",
                                                      placement: "bottom",
                                                    },
                                                  },
                                                  [
                                                    _vm.status(row.status) ===
                                                    "Payment Sent"
                                                      ? _c("BadgeInfoIcon")
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "status-chevron",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleDropdown(
                                                      row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_c("ChevronIcon")],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.openDropdown === row.id
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "absolute action-button-dropdown bg-white",
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "action-button__list cursor-pointer",
                                                  },
                                                  [
                                                    _c(
                                                      "li",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeSignalStatus(
                                                              "APPROVED"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Invoice Approved "
                                                        ),
                                                      ]
                                                    ),
                                                    row.status !== "APPROVED"
                                                      ? _c(
                                                          "li",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.changeSignalStatus(
                                                                  "REJECTED"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Invoice Rejected "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "li",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeSignalStatus(
                                                              "PAYMENT SEND"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" Payment Sent ")]
                                                    ),
                                                    _c(
                                                      "li",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeSignalStatus(
                                                              "PAID"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" Paid ")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "submittedBy",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "user" }, [
                                        row.submittedBy.image
                                          ? _c(
                                              "div",
                                              { staticClass: "user-image" },
                                              [
                                                _c("S3Image", {
                                                  staticClass:
                                                    "inline-block h-10 w-10 rounded-full object-cover object-center innerBorder",
                                                  attrs: {
                                                    s3FileKey:
                                                      row.submittedBy.image,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "user-initials" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.submittedBy.initials
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.submittedBy.name)),
                                        ]),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "actions",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "actions flex items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editRow(row)
                                                },
                                              },
                                            },
                                            [_c("TableViewIcon")],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCopy(row)
                                                },
                                              },
                                            },
                                            [_c("CopyLink")],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-1",
                        fn: function () {
                          return [
                            _vm.currentUser.role === "ADMIN" &&
                            _vm.selectedRows.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "invoice-buttons" },
                                  [
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Approved",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("APPROVED")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Rejected",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("REJECTED")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Pending Approval",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("PENDING")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Paid",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus("PAID")
                                        },
                                      },
                                    }),
                                    _c("UiButton", {
                                      attrs: {
                                        type: "button",
                                        buttonText: "Mark as Payment Sent",
                                        buttonClasses:
                                          "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                        variant: "white",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeStatus(
                                            "PAYMENT SEND"
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("TableView", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                columns: _vm.columns,
                                data: _vm.invoiceData,
                                hasActions: true,
                                selectedRows: _vm.selectedRows,
                              },
                              on: {
                                sort: _vm.handleSort,
                                "update:selectedRows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                                "update:selected-rows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "status",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "status",
                                          class: row.status,
                                        },
                                        [_vm._v(_vm._s(_vm.status(row.status)))]
                                      ),
                                      _c("ChevronIcon", {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDropdown(row.id)
                                          },
                                        },
                                      }),
                                      _vm.openDropdown === row.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "absolute action-button-dropdown bg-white",
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "action-button__list",
                                                },
                                                [
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "APPROVED"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Invoice Approved "
                                                      ),
                                                    ]
                                                  ),
                                                  row.status !== "APPROVED"
                                                    ? _c(
                                                        "li",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeSignalStatus(
                                                                "REJECTED"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Invoice Rejected "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "PAYMENT SEND"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Payment Sent ")]
                                                  ),
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "PAID"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Paid ")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "submittedBy",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "user" }, [
                                        row.submittedBy.image
                                          ? _c(
                                              "div",
                                              { staticClass: "user-image" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: row.submittedBy.image,
                                                    alt: row.submittedBy.name,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "user-initials" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.submittedBy.initials
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.submittedBy.name)),
                                        ]),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "actions",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "actions flex items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editRow(row)
                                                },
                                              },
                                            },
                                            [_c("TableViewIcon")],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCopy(row)
                                                },
                                              },
                                            },
                                            [_c("CopyLink")],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-2",
                        fn: function () {
                          return [
                            _c("TableView", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                columns: _vm.columns,
                                data: _vm.invoiceData,
                                hasActions: true,
                                selectedRows: _vm.selectedRows,
                              },
                              on: {
                                sort: _vm.handleSort,
                                "update:selectedRows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                                "update:selected-rows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "status",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "status",
                                          class: row.status,
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.status(row.status)) + " "
                                          ),
                                        ]
                                      ),
                                      _c("ChevronIcon", {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDropdown(row.id)
                                          },
                                        },
                                      }),
                                      _vm.openDropdown === row.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "absolute action-button-dropdown bg-white",
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "action-button__list",
                                                },
                                                [
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "APPROVED"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Invoice Approved "
                                                      ),
                                                    ]
                                                  ),
                                                  row.status !== "APPROVED"
                                                    ? _c(
                                                        "li",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeSignalStatus(
                                                                "REJECTED"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Invoice Rejected "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "PAYMENT SEND"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Payment Sent ")]
                                                  ),
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "PAID"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Paid ")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "submittedBy",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "user" }, [
                                        row.submittedBy.image
                                          ? _c(
                                              "div",
                                              { staticClass: "user-image" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: row.submittedBy.image,
                                                    alt: row.submittedBy.name,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "user-initials" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.submittedBy.initials
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.submittedBy.name)),
                                        ]),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "actions",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "actions flex items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editRow(row)
                                                },
                                              },
                                            },
                                            [_c("TableViewIcon")],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCopy(row)
                                                },
                                              },
                                            },
                                            [_c("CopyLink")],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "tab-3",
                        fn: function () {
                          return [
                            _c("TableView", {
                              attrs: {
                                sort_by: _vm.sortBy,
                                sort_direction: _vm.sortDirection,
                                columns: _vm.columns,
                                data: _vm.invoiceData,
                                hasActions: true,
                                selectedRows: _vm.selectedRows,
                              },
                              on: {
                                sort: _vm.handleSort,
                                "update:selectedRows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                                "update:selected-rows": function ($event) {
                                  _vm.selectedRows = $event
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "status",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "status",
                                          class: row.status,
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.status(row.status)) + " "
                                          ),
                                        ]
                                      ),
                                      _c("ChevronIcon", {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDropdown(row.id)
                                          },
                                        },
                                      }),
                                      _vm.openDropdown === row.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "absolute action-button-dropdown bg-white",
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "action-button__list",
                                                },
                                                [
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "APPROVED"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Invoice Approved "
                                                      ),
                                                    ]
                                                  ),
                                                  row.status !== "APPROVED"
                                                    ? _c(
                                                        "li",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeSignalStatus(
                                                                "REJECTED"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Invoice Rejected "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "PAYMENT SEND"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Payment Sent ")]
                                                  ),
                                                  _c(
                                                    "li",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeSignalStatus(
                                                            "PAID"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Paid ")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "submittedBy",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "user" }, [
                                        row.submittedBy.image
                                          ? _c(
                                              "div",
                                              { staticClass: "user-image" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: row.submittedBy.image,
                                                    alt: row.submittedBy.name,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "user-initials" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.submittedBy.initials
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                        _c("span", [
                                          _vm._v(_vm._s(row.submittedBy.name)),
                                        ]),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "actions",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "actions flex items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editRow(row)
                                                },
                                              },
                                            },
                                            [_c("TableViewIcon")],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "action-button mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCopy(row)
                                                },
                                              },
                                            },
                                            [_c("CopyLink")],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.activeTabIndex,
                      callback: function ($$v) {
                        _vm.activeTabIndex = $$v
                      },
                      expression: "activeTabIndex",
                    },
                  },
                  [
                    _vm.currentUser.role === "ADMIN" &&
                    _vm.selectedRows.length > 0
                      ? _c(
                          "div",
                          { staticClass: "invoice-buttons" },
                          [
                            _c("UiButton", {
                              attrs: {
                                type: "button",
                                buttonText: "Mark as Approved",
                                buttonClasses:
                                  "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStatus("APPROVED")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                type: "button",
                                buttonText: "Mark as Rejected",
                                buttonClasses:
                                  "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStatus("REJECTED")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                type: "button",
                                buttonText: "Mark as Pending Approval",
                                buttonClasses:
                                  "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStatus("PENDING")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                type: "button",
                                buttonText: "Paid",
                                buttonClasses:
                                  "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStatus("PAID")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                type: "button",
                                buttonText: "Mark as Payment Sent",
                                buttonClasses:
                                  "px-2 pr-4 pl-4 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeStatus("PAYMENT SEND")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
            _c("Pagination", {
              attrs: {
                limit: _vm.limit,
                current: _vm.currentPage,
                total: _vm.totalPages,
                paginationClasses: "timesheet_table_pagination",
              },
              on: {
                "limit-change": _vm.onLimitChange,
                "next-page": function ($event) {
                  return _vm.changePage(1)
                },
                "prev-page": function ($event) {
                  return _vm.changePage(-1)
                },
              },
            }),
          ],
          1
        ),
        _c("CancelInvoiceModal", {
          on: {
            cancelInvoice: function ($event) {
              return _vm.confirmCancelInvoice("CANCEL")
            },
          },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }